module.exports = __webpack_public_path__ + "img/Uzbekistan.04734e71.gif";